import styled from "styled-components";

export const InternalLink = styled.span`
  cursor: pointer;
`;

export const ExternalLink = styled.a``;
